{
  "title": "Manage Drivers",
  "statusUpdated": "Driver status updated successfully",
  "invitationSent": "Invitation sent successfully",
  "resendSuccess": "Invitation resent successfully",
  "search": "Search",
  "loading": "Loading drivers...",
  "name": "Name",
  "email": "E-mail",
  "status": "Status",
  "vehiclesColumn": "Vehicles",
  "actions": "Actions",
  "deactivate": "Deactivate",
  "activate": "Activate",
  "invitations": "Invitations",
  "inviteNewDriver": "Invite Driver",
  "loadingInvitations": "Loading invitations...",
  "noInvitations": "No pending invitations.",
  "invitePending": "Invitation pending.",
  "resend": "Resend",
  "of": "of",
  "statusLabels": {
    "active": "Active",
    "inactive": "Inactive",
    "new": "New",
    "deactivated": "Deactivated",
    "covered": "Coverage active",
    "awaitingCoverage": "Awaiting coverage",
    "awaitingLicense": "Awaiting license",
    "associated": "Associated",
    "pending": "Pending",
    "invited": "Invited"
  },
  "statusTabs": {
    "all": "All",
    "archived": "Inactive"
  },
  "funding": {
    "company": "Company pays",
    "self": "Personal license",
    "ambiguous": "Needs review",
    "uncovered": "Uncovered",
    "hidden": "Hidden drivers",
    "covered": "Coverage active",
    "awaiting": "Awaiting coverage",
    "notCovered": "No active coverage",
    "associated": "Associated with company",
    "deactivated": "Association deactivated",
    "relationship": "Relationship state",
    "summaryTitle": "License and funding",
    "relationshipLabel": "Company relationship",
    "payerLabel": "License paid by",
    "coverageLabel": "Coverage",
    "personalCoverageLabel": "Personal coverage",
    "companyCoverageLabel": "Company coverage",
    "corporateSeatUseLabel": "Company-seat use",
    "relationshipStates": {
      "active": "Active",
      "associated": "Associated with the company",
      "pending": "Pending",
      "deactivated": "Deactivated",
      "unknown": "Unknown"
    },
    "payers": {
      "company": "Company",
      "self": "Driver (self-pay)",
      "ambiguous": "Needs review",
      "uncovered": "No active payer",
      "unknown": "Unknown"
    },
    "compactStatuses": {
      "active": "Active",
      "awaiting": "Awaiting license",
      "pending": "Pending",
      "deactivated": "Deactivated",
      "notCovered": "No active license",
      "associated": "Associated",
      "unknown": "Unknown"
    },
    "compactPayers": {
      "company": "Company pays",
      "self": "Self-pay",
      "ambiguous": "To confirm",
      "uncovered": "No active payer",
      "unknown": "Unknown"
    },
    "coverageStates": {
      "active": "Active",
      "awaiting": "Awaiting coverage",
      "not_covered": "No active coverage",
      "unknown": "Unknown"
    },
    "corporateSeatUse": {
      "self": "0 — personal license; no company seat",
      "none": "0 — no company seat",
      "company_one": "{{count}} company seat",
      "company_other": "{{count}} company seats",
      "ambiguous": "{{count}} — needs review; counted in company use",
      "uncovered": "0 — no active coverage",
      "unknown": "Unknown"
    },
    "licenseIssues": {
      "paymentOverdue": "Payment overdue",
      "canceledNonpayment": "Cancelled — payment failed",
      "paymentOverdueAction": "{{name}} can't log work until the payment is fixed. Ask them to update their payment method, or send them a new company-paid invitation under Drivers.",
      "canceledNonpaymentAction": "{{name}} can no longer log work. Ask them to activate a new license, or send them a new company-paid invitation under Drivers.",
      "thisDriver": "This driver"
    }
  },
  "filters": {
    "title": "Filters",
    "search": "Search",
    "status": "Relationship status",
    "payer": "License paid by",
    "visibility": "Report visibility",
    "showHidden": "Show drivers hidden from reports",
    "showMore": "More filters",
    "showFewer": "Fewer filters",
    "needsAttention": "Needs attention",
    "dataToConfirm": "Data to confirm",
    "noActiveLicense": "No active license",
    "sort": "Sort by",
    "licensePaymentIssue": "License payment failed"
  },
  "newest": "Newest",
  "oldest": "Oldest",
  "az": "A-Z",
  "za": "Z-A",
  "sortByDate": "Date",
  "sortByName": "Name",
  "sortLabel": "Sort by",
  "noResults": "No results",
  "page": "Page",
  "showing": "Showing",
  "drivers": "drivers",
  "registrationDate": "Registry",
  "activated": "Activated",
  "deactivated": "Deactivated",
  "common": {
    "all": "All",
    "status": "Status",
    "previous": "Previous",
    "next": "Next",
    "ok": "OK",
    "cancel": "Cancel"
  },
  "ownerDashboard": {
    "inviteDriver": "Invite Driver"
  },
  "error": "Error",
  "errorFetchingDrivers": "Error fetching drivers",
  "errorUpdatingStatus": "Error updating driver status",
  "errorSendingInvitation": "Error sending invitation",
  "errorResendingInvitation": "Error resending invitation",
  "errorFetchingInvitations": "Error fetching invitations",
  "errorCancelingInvitation": "Error canceling invitation",
  "noDriversFound": "No drivers found",
  "invitationsPending": "pending",
  "expired": "Expired",
  "expiresToday": "Expires today",
  "expiresTomorrow": "Expires tomorrow",
  "expiresInDays": "Expires in {{days}} days",
  "expiresAt": "Expires at",
  "pending": "Pending",
  "workStartDate": "Work start date",
  "driverDetailsTitle": "Driver Details",
  "driverDetails": {
    "personalInfo": "Personal Information",
    "employmentInfo": "Employment Information",
    "phoneNumber": "Phone Number",
    "address": "Address",
    "licenseNumber": "CMTVDE",
    "workStartDate": "Professional Work Start Date",
    "startDate": "Company Start Date",
    "status": "Status",
    "updatingStatus": "Updating status...",
    "emailVerified": "Email is verified. Cannot be changed.",
    "emailUnverified": "Email is not verified. You can change it, but verification will be required.",
    "reportExportTitle": "Weekly hours report",
    "reportExportDescription": "Export the selected driver weekly hours report as a PDF. The week start date defaults to the current Monday.",
    "weekStart": "Week start",
    "exportHoursReportPdf": "Export hours report (PDF)",
    "exportError": "Error exporting weekly hours report.",
    "exportShareUnavailable": "Sharing is not available on this device.",
    "shareReportTitle": "Share weekly hours report",
    "reportHidden": "Hidden from company reports",
    "reportHiddenDescription": "This is reversible. Hidden drivers require explicit inclusion in exports.",
    "hiddenExportIncluded": "This export will explicitly include the hidden driver.",
    "reportHiddenError": "Error updating report visibility.",
    "relationshipControlTitle": "Company relationship",
    "relationshipActivationLabel": "Activation by company",
    "selfPaySummary": "Driver pays · No company seat"
  },
  "vehicles": {
    "allVehicles": "All Vehicles",
    "allDrivers": "All Drivers",
    "searchVehicles": "Search by registration, make, model, or year...",
    "searchDrivers": "Search drivers...",
    "assignedTo": "Assigned to:",
    "assignedVehicles": "Assigned vehicles:",
    "assigned": "Assigned",
    "dropHereToAssign": "Drop here to assign!",
    "dragToAssign": "Drag to assign or drop here",
    "selectVehicle": "Select a vehicle to assign",
    "assignToDriver": "Assign to Driver",
    "unassignFromDriver": "Unassign",
    "editVehicle": "Edit Vehicle",
    "addVehicle": "Add Vehicle",
    "vehicleAssigned": "Vehicle assigned successfully",
    "vehicleUnassigned": "Vehicle unassigned successfully",
    "vehicleCreated": "Vehicle created successfully",
    "vehicleUpdated": "Vehicle updated successfully",
    "errorAssigningVehicle": "Error assigning vehicle",
    "errorUnassigningVehicle": "Error unassigning vehicle",
    "errorSavingVehicle": "Error saving vehicle",
    "vehicleAlreadyExistsInCompany": "This vehicle already belongs to your company.",
    "vehicleAssociatedWithCompany": "Vehicle was associated with your company.",
    "errorAssociatingVehicle": "Error associating vehicle with company.",
    "registrationNumberError": "Invalid registration number format.",
    "noVehiclesSelected": "No vehicle selected",
    "assignmentMethods": "Assignment Methods:",
    "dragInstructions": "To assign, drag the vehicle card to the driver card (or vice versa). Alternatively, click on a card to select it and then click 'Assign'.",
    "assignSelected": "Assign Selected",
    "previous": "Previous",
    "next": "Next",
    "registrationNumber": "Registration Number",
    "make": "Make",
    "model": "Model",
    "year": "Year",
    "fuelType": "Fuel Type",
    "dragToAssignDriver": "💡 Drag to assign or drop a driver here",
    "dragToAssignVehicle": "💡 Drag to assign or drop a vehicle here",
    "noVehicles": "No vehicles added yet.",
    "addFirstVehicle": "Add First Vehicle",
    "moreVehicles": "+{count} more vehicles",
    "assignAVehicle": "Assign a Vehicle",
    "update": "Update",
    "create": "Create",
    "manageVehicles": "Manage Vehicles",
    "totalVehicles": "Vehicles",
    "unassigned": "Unassigned",
    "availableVehicles": "Available Vehicles",
    "noVehiclesMatchSearch": "No vehicles match your search",
    "allVehiclesAssigned": "All vehicles are assigned to this driver",
    "assign": "Assign",
    "assignVehicles": "Assign Vehicles",
    "selected": "selected",
    "select": "Select",
    "noVehiclesFound": "No vehicles found matching your search",
    "noAvailableVehicles": "No available vehicles to assign",
    "noDetails": "No additional details",
    "selectAtLeastOne": "Please select at least one vehicle",
    "loadError": "Unable to load vehicles",
    "assignError": "Error assigning vehicles",
    "noAssignedVehicles": "No vehicles assigned",
    "delete": "Delete",
    "remove": "Remove",
    "confirmRemove": "Remove Vehicle from Company",
    "removeMessage": "Are you sure you want to remove vehicle {{registration}} from your company? The vehicle will remain in the database but will no longer be associated with your company.",
    "vehicleRemoved": "Vehicle removed from company successfully",
    "errorRemovingVehicle": "Error removing vehicle from company"
  },
  "transfers": {
    "title": "Transfer Requests",
    "pendingTransfers": "Pending Transfers",
    "loading": "Loading transfers...",
    "noRequests": "No pending requests",
    "approve": "Approve",
    "reject": "Reject",
    "approveSuccess": "Transfer approved successfully",
    "rejectSuccess": "Transfer rejected",
    "errorApproving": "Error approving transfer",
    "errorRejecting": "Error rejecting transfer",
    "errorFetching": "Error fetching transfers",
    "driverInfo": "Driver Information",
    "currentCompany": "Current Company",
    "reason": "Reason",
    "requestedAt": "Requested on",
    "confirmApprove": "Confirm Approval",
    "confirmReject": "Confirm Rejection",
    "approveMessage": "Are you sure you want to approve the transfer for {{name}}? The driver will be automatically transferred to your company.",
    "rejectMessage": "Are you sure you want to reject the transfer for {{name}}?",
    "confirm": "Confirm",
    "cancel": "Cancel",
    "from": "From",
    "status": {
      "pending": "Pending",
      "approved": "Approved",
      "rejected": "Rejected"
    }
  },
  "bulkActions": {
    "selected": "Selected: {{count}}",
    "selectAll": "Select All",
    "transfer": "Transfer",
    "activate": "Activate",
    "transferDrivers": "Transfer {{count}} Drivers",
    "transferDriversDescription": "Select the target company to transfer the selected drivers to.",
    "transferResult": "Transferred {{success}} driver(s). {{errors}} error(s).",
    "transferError": "Error transferring drivers: {{error}}",
    "transferLicenseError": "Target company has no available driver licenses.",
    "activateResult": "Activated {{success}} driver(s). {{errors}} error(s).",
    "activateError": "Error activating drivers: {{error}}",
    "noInactiveDrivers": "No inactive drivers selected",
    "noDriversSelected": "No drivers selected",
    "result": "Operation Result",
    "licenseErrors": "License issues:\n{{errors}}",
    "buyLicensesHint": "Please purchase additional licenses to activate more drivers. Go to your subscription page to buy more licenses.",
    "licenseError": "You need to purchase licenses to activate drivers.",
    "licenseErrorTitle": "Licenses Required",
    "licenseErrorDescription": "To activate this driver, you need to purchase additional driver licenses. Click the button below to go to your licenses management page.",
    "goToLicenses": "Go to Licenses"
  },
  "transfer": {
    "alsoTransferVehicles": "Also transfer {{count}} related vehicles",
    "alsoTransferDrivers": "Also transfer {{count}} related drivers",
    "selectCompany": "Please select a target company",
    "error": "Error transferring",
    "noOtherCompanies": "You need at least one other company to transfer to.",
    "errorLoadingCompanies": "Error loading companies",
    "transferButton": "Transfer",
    "licenseError": "Target company has no available driver licenses."
  }
}
